<template>
  <Modal
    no-cancel
    :tracking="{
      action: 'checkout',
      topicKey: 'player-status-restriction',
    }"
    @confirm="navigateToLocalized('/account')"
  >
    <template #headline>
      {{ $t(`checkout.restrictions.player.${status}.headline`) }}
    </template>

    <i18n-t :keypath="`checkout.restrictions.player.${status}.message`" scope="global" tag="p">
      <template #contactSupport>
        <a class="text-link" :href="$localePath('/service?chat=true')">
          {{ $t('common.sentences.contactsupport').toLowerCase() }}
        </a>
      </template>
    </i18n-t>

    <template #confirm>
      {{ $t(`checkout.restrictions.player.${status}.confirm`) }}
    </template>
  </Modal>
</template>

<script lang="ts" setup>
import type {
  PlayerCheckStatus,
  Status,
} from '#api/shared/@types/generated/backend/graphql-schema-types'

type CheckoutRestrictionsPlayerModalProps = {
  status: PlayerCheckStatus | Status
}

const { navigateToLocalized } = useRouterUtils()

defineProps<CheckoutRestrictionsPlayerModalProps>()
</script>
